export const frag = /*glsl*/ `
uniform sampler2D tDiffuse;
uniform sampler2D tNoise;
uniform sampler2D tLinearNoise;
uniform float uTime;
uniform vec3 eye;
uniform vec3 uColor;

varying vec4 worldPosition;
varying vec4 vUv;
varying vec2 vGeometryUv;
#define PI 3.141592

vec3 czm_saturation(vec3 rgb, float adjustment) {
    return mix(vec3(dot(rgb, vec3(0.2125, 0.7154, 0.0721))), rgb, adjustment);
}

vec3 hueShift(vec3 color, float hue) {
    vec3 k = vec3(0.57735, 0.57735, 0.57735);
    float cosAngle = cos(hue);
    return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
}

void main() {

	vec3 worldToEye = eye - worldPosition.xyz;
	vec3 eyeDirection = normalize( worldToEye );

	float distance = length(worldToEye);
	float l = length(vGeometryUv - .5);
	float vignet = smoothstep(.5, .2, l);

	vec4 noise = vec4(texture2D(tNoise, vUv.xy) - .5) * .02;
	vec3 reflectionSample = texture2DProj( tDiffuse, vUv + noise).rgb;
	reflectionSample = (reflectionSample * (smoothstep(1.5, .0, distance) + .3));

	reflectionSample = czm_saturation(reflectionSample, .8);
	vec3 base = mix(reflectionSample, uColor, smoothstep(.995, .9951, texture2D(tNoise, vGeometryUv.xy * 3.).a * smoothstep(.5, .2, l))) * .5;

	gl_FragColor = vec4(base * 2., 1.);
	
	vec2 cUv = (vGeometryUv - 0.5) * 1.7;
	vec2 sUv = vec2(length(cUv), fract(atan(cUv.x, cUv.y) / (PI * 2.) - uTime * .001 + length(cUv) * texture2D(tLinearNoise, vec2(length(cUv) + uTime * 0.00001)) * 10.));

	float r = .18;
	float intensity = smoothstep(r - .02, r - .01, sUv.x) * smoothstep(r + .02, r + .01, sUv.x) * smoothstep(-.5, .7, sUv.y) * smoothstep(1., .7, sUv.y) * texture2D(tLinearNoise, vec2(sUv.x * .5)).r * 2.;
	intensity += smoothstep(r / 3., r, sUv.x) * smoothstep(r * 2., r, sUv.x) * smoothstep(.0, .9, sUv.y) * smoothstep(1., .9, sUv.y) * .05;
	
	vec3 color = intensity * uColor;
	color = hueShift(color, intensity * .7);

	gl_FragColor += vec4(color, 0.);
	gl_FragColor -= smoothstep(.2, 0., length(cUv)) * .1;
	gl_FragColor *= vignet;
}`;
